import Vue from 'vue'
import App from './App.vue'
import Router from "vue-router";
import iView from 'iview';
import locale from 'iview/dist/locale/en-US';
import 'iview/dist/styles/iview.css';
import global from './components/Common.vue';
import VueI18n from 'vue-i18n';

import Home from './views/Home';
import Inform from './views/Inform';
import Loading from './views/Loading';
import A_fake from './views/A_fake';
import A_nonactivate from './views/A_nonactivate';
import A_activate from './views/A_activated';
import A_nonrecord from './views/A_nonrecord';
import A_error from './views/A_error';
import B_fake from './views/B_fake';
import B_bind from './views/B_bind';
import Query_result from './views/Query_result';
import Scan from './views/Scan';

import LangEn from './i18n/lang/en.js';
import LangCn from './i18n/lang/cn.js';

import '../public/css/app.css'

import Vconsole from 'vconsole';

process.env.NODE_ENV === 'development' && new Vconsole()

Vue.prototype.common = global;
Vue.use(Router);
Vue.use(iView, {locale: locale});
Vue.use(VueI18n);

Vue.config.productionTip = false;

(function (doc, win) {
    let docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
            let clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            if (clientWidth >= 750) {
                docEl.style.fontSize = '100px';
            } else {
                docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
            }
        };
    
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

const routes = [
    {
        path: '/',
        component: Home,
        name: 'Home'
    }, {
        path: '/query_result',
        component: Query_result,
        name: 'Query_result',
        children: [{
            path: 'a_fake',
            component: A_fake,
            name: 'A_fake'
        }, {
            path: 'a_nonactivate',
            component: A_nonactivate,
            name: 'A_nonactivate'
        }, {
            path: 'a_activate',
            component: A_activate,
            name: 'A_activate'
        }, {
            path: 'a_nonrecord',
            component: A_nonrecord,
            name: 'A_nonrecord'
        }, {
            path: 'a_error',
            component: A_error,
            name: 'A_error'
        }, {
            path: 'b_fake',
            component: B_fake,
            name: 'B_fake'
        }, {
            path: 'b_bind',
            component: B_bind,
            name: 'B_bind'
        }]
    }, {
        path: '/inform',
        component: Inform,
        name: 'Inform'
    }, {
        path: '/s/:code',
        component: Loading,
        name: 'Loading'
    }, {
        path: '/scan',
        component: Scan,
        name: 'Scan'
    }
];

const router = new Router({
    mode: 'history',
    routes // (缩写) 相当于 routes: routes
});

const messages = {
    'en': LangEn,
    'cn': LangCn
};

const i18n = new VueI18n({
    locale: 'en',
    messages
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
